import { Route } from "@angular/router";
import { UploadImageService } from "../api/services/upload-image.service";
import { VehicleTypesListComponent } from "./components/vehicle-types-list/vehicle-types-list.component";
import { VehicleTypesService } from "../api/services/vehicle-types.service";

export default [
  {
    path: '',
    title: 'Te Llevo-Dashboard',
    component: VehicleTypesListComponent,
    providers: [VehicleTypesService, UploadImageService],
  },
] as Route[];